import { useEffect, useState } from 'react';

/** Returns ms remaining until `deadlineAt`. `null` when `deadlineAt` is undefined; `0` after deadline. */
export const useCountdown = (deadlineAt: number | undefined): number | null => {
  const [remaining, setRemaining] = useState<number | null>(() =>
    deadlineAt === undefined ? null : Math.max(0, deadlineAt - Date.now()),
  );

  useEffect(() => {
    if (deadlineAt === undefined) {
      setRemaining(null);
      return;
    }
    const compute = (): number => Math.max(0, deadlineAt - Date.now());
    setRemaining(compute());
    const id = setInterval(() => {
      setRemaining(compute());
    }, 250);
    return () => clearInterval(id);
  }, [deadlineAt]);

  return remaining;
};

/** Format `m:ss`. Negative or `null` renders as `0:00`. */
export const formatCountdown = (ms: number | null): string => {
  const total = Math.max(0, Math.ceil((ms ?? 0) / 1000));
  const minutes = Math.floor(total / 60);
  const seconds = total % 60;
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};
